<template>
  <label
    class="border rounded w-100 cursor-pointer"
    style="padding: 1rem 0.75rem"
    :style="{
      borderColor: errors && errors.length > 0 ? '#dc3545!important' : '#ced4da!important',
    }"
  >
    Logo
    <button
      ref="popoverElement"
      type="button"
      class="btn btn-primary-outline p-0"
      data-bs-container="body"
      data-bs-toggle="popoverElement"
      data-bs-placement="top"
      data-bs-content="max. 16MB; JPG oder PNG; Hintergrund Transparent; Auflösung max. 3508x3508"
    >
      <i class="bi bi-info-circle text-primary fs-6"></i>
    </button>

    <div class="border rounded mt-2 position-relative p-1" style="height: 10rem; background: #dee2e6">
      <input
        id="upload"
        class="form-control h-100 opacity-0 position-absolute"
        type="file"
        @change="$emit('uploadImage', $event)"
      />
      <div
        v-if="imageUrl"
        class="preview h-100"
        :style="{
          background: 'url(\'' + imageUrl + '\') no-repeat center/contain',
        }"
      ></div>
      <button
        v-if="imageUrl"
        type="button"
        class="btn border text-muted hover:text-primary position-absolute bg-white"
        style="top: 1rem; right: 1rem"
        @click="$emit('deleteImage')"
      >
        <i class="bi bi-trash-fill"></i>
      </button>
      <div v-else class="d-flex justify-content-center align-items-center top-0 left-0 h-100 w-100 fs-5">
        Datei auswählen oder hierhin ziehen
      </div>
    </div>
  </label>
  <template v-if="errors && errors.length > 0">
    <div v-for="(error, index) in errors" :key="index" class="invalid-feedback d-block" role="alert">
      <strong>{{ error }}</strong>
    </div>
  </template>
</template>

<script>
import { ref, onMounted, onUnmounted } from 'vue';
export default {
  props: {
    errors: {
      type: Array,
      default: null,
    },
    imageUrl: {
      type: String,
      default: '',
    },
  },
  emits: ['uploadImage', 'deleteImage'],
  setup() {
    const popoverElement = ref('');
    const popoverInstance = ref('');

    onMounted(() => {
      popoverInstance.value = new window.bootstrap.Popover(popoverElement.value);
    });

    onUnmounted(() => {
      popoverInstance.value.dispose();
    });

    return {
      popoverElement,
    };
  },
};
</script>

<style lang="scss" scoped></style>
